import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ITitleProps {
  title: string;
  url: string;
}

export const Title: React.FC<ITitleProps> = ({ title, url }) => {
  return (
    <div className={styles['title']}>
      <UIHeading2 color="text-main-default">
        <a href={url} target="_blank" rel="noreferrer" className={styles['link']}>
          {title}
        </a>
      </UIHeading2>
    </div>
  );
};
